import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { createElement } from "react";
import { Box } from "@mantine/core";
import { Parser, ProcessNodeDefinitions } from "html-to-react";
import { CollectionCard } from "./collection-card/CollectionCard";
import { Timer } from "./timer/Timer";
/* eslint-disable @typescript-eslint/no-explicit-any */
const HLComponentsMap = {
    // TODO JJ: replace this when moving builder to shared-features
    // [HLCollectionCardPlugin.type]: CollectionCard,
    "hl-collection-card": CollectionCard,
    "hl-timer": Timer,
};
export const CustomPageRenderer = (props) => {
    const { htmlString, cssString } = props;
    const htmlInput = htmlString
        .replace(/<body[^>]*>/, "<div>")
        .replace("</body>", "</div>");
    // @ts-ignore
    const htmlToReactParser = new Parser();
    // @ts-ignore
    const processNodeDefinitions = new ProcessNodeDefinitions();
    const isValidNode = function () {
        return true;
    };
    const processingInstructions = [
        {
            // This is REQUIRED, it tells the parser
            // if we want to insert our React
            // component as a child or replace it
            replaceChildren: false,
            shouldProcessNode: function (node) {
                if (node.name !== "div")
                    return false;
                const type = node.attribs["data-gjs-type"];
                const hlComponent = HLComponentsMap[type];
                if (hlComponent == null)
                    return false;
                // console.log("Processing none", { type, hlComponent, node });
                return true;
            },
            processNode: function (node, children) {
                var _a;
                const type = node.attribs["data-gjs-type"];
                /* eslint-disable @typescript-eslint/no-explicit-any */
                const hlComponent = HLComponentsMap[type];
                /* eslint-disable @typescript-eslint/no-explicit-any */
                const props = JSON.parse((_a = children[0]) !== null && _a !== void 0 ? _a : "{}");
                return createElement(hlComponent, props);
            },
        },
        {
            // Anything else
            shouldProcessNode: function () {
                return true;
            },
            processNode: processNodeDefinitions.processDefaultNode,
        },
    ];
    const reactComponent = htmlToReactParser.parseWithInstructions(htmlInput, isValidNode, processingInstructions);
    // const reactHtml = ReactDOMServer.renderToStaticMarkup(reactComponent);
    return (_jsxs(Box, { id: "custom-page-renderer", children: [_jsx("style", { dangerouslySetInnerHTML: { __html: cssString } }), reactComponent] }));
};
